import { Resolver } from 'craft/types';

import { Alert } from './Alert';
import { Badge } from './Badge';
import { Button } from './Button';
import { Card } from './Card';
import { CheckList, CheckListGroup, CheckListItem } from './CheckList';
import { Code } from './Code';
import { Collection } from './Collection';
import { CollectionItem } from './CollectionItem';
import { Column, Columns } from './Columns';
import { ConditionalView, ConditionalViewOption } from './ConditionalView';
import { Document } from './Document';
import { EmbedContent } from './EmbedContent';
import { Flow, FlowStep } from './Flow';
import {
  Form,
  FormCheckboxList,
  FormSelectInput,
  FormStep,
  FormSubmitButton,
  FormTextarea,
  FormTextInput,
  FormMultiSelectCardGroup,
  FormMultiSelectCard,
  FormSingleSelectCardGroup,
  FormSingleSelectCard,
} from './Forms';
import { Hotspot } from './Hotspot';
import { HotspotGroup } from './HotspotGroup';
import { IFrame } from './IFrame';
import { Image } from './Image';
import { Link } from './Link';
import { List } from './List';
import { ListItem } from './ListItem';
import { Modal } from './Modal';
import { Player } from './Player';
import { RichText } from './RichText';
import { Spacing } from './Spacing';
import { Text } from './Text';
import { Tour } from './Tour';
import { TourStep } from './TourStep';
import { Typography } from './Typography';
import { Variable } from './Variable';
import { View } from './View';

export const resolvers: Record<string, Resolver> = {
  Alert,
  Badge,
  Button,
  Card,
  CheckList,
  CheckListGroup,
  CheckListItem,
  Code,
  Collection,
  CollectionItem,
  Column,
  Columns,
  ConditionalView,
  ConditionalViewOption,
  EmbedContent,
  // TODO remove this fail safe once we're sure there's no one emebed Tutorial/Portal on our clients
  EmbedPortal: EmbedContent,
  EmbedTutorial: EmbedContent,
  Form,
  FormStep,
  FormSubmitButton,
  FormTextInput,
  FormTextarea,
  FormSelectInput,
  FormCheckboxList,
  FormMultiSelectCardGroup,
  FormMultiSelectCard,
  FormSingleSelectCardGroup,
  FormSingleSelectCard,
  Flow,
  FlowStep,
  IFrame,
  Document,
  Hotspot,
  HotspotGroup,
  Modal,
  Spacing,
  Image,
  Player,
  List,
  ListItem,
  Link,
  RichText,
  Text,
  Typography,
  Tour,
  TourStep,
  Variable,
  View,
};
